/**
 * Initializes a Project select, used to assign users to a project
 *
 * @param {Element} element
 * @param {Object} settings
 * @return {JQuery<HTMLElement>}
 */
function initProjectAssignmentSelect(element, settings = {}) {

	const defaultSettings = {
		theme: 'bootstrap4',
	};

	const finalSettings = {
		...defaultSettings,
		...settings,
	}
	return $(element).select2(finalSettings);
}

export {initProjectAssignmentSelect}
